import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { faChartArea } from '@fortawesome/free-solid-svg-icons'

import PageTitle from './partials/PageTitle'
import MenuWidget from './partials/MenuWidget'

export default function MomentosDashboard() {
	return (
		<React.Fragment>
			<PageTitle title="Ventas Momentos Spring" subtitle="Reportes relacionados a las ventas asociadas al programa de Momentos Spring." />
			<Row>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Recompra Momentos"
						subtitle="Atribución según metricas de nuevo modelo (2026)"
						icon={faChartArea}
						linkTo={"/momentos/recompra_total"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Gestión Email Marketing"
						subtitle="Atribución según metricas de nuevo modelo (2026)"
						icon={faChartArea}
						linkTo={"/momentos/gestion_email_marketing"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Gestión Cumpleaños"
						subtitle="Atribución según metricas de nuevo modelo (2026)"
						icon={faChartArea}
						linkTo={"/momentos/gestion_cumpleanos"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Gestión Tiendas"
						subtitle="Atribución según metricas de nuevo modelo (2026)"
						icon={faChartArea}
						linkTo={"/momentos/gestion_tiendas"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Gestión SMS Marketing"
						subtitle="Atribución según metricas de nuevo modelo (2026)"
						icon={faChartArea}
						linkTo={"/momentos/gestion_sms_marketing"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Otros (Organico)"
						subtitle="Atribución según metricas de nuevo modelo (2026)"
						icon={faChartArea}
						linkTo={"/momentos/organico"}
					/>
				</Col>
			</Row>
		</React.Fragment>
	)
}